import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './AuthContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();

// ============================================
// Progressive Web App - Service Worker Registration
// ============================================
if ('serviceWorker' in navigator) {
  // Daftarkan service worker setelah halaman selesai dimuat
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' })
      .then((registration) => {
        console.log('[PWA] Service Worker registered with scope:', registration.scope);

        // Detect SW update
        registration.addEventListener('updatefound', () => {
          const installingWorker = registration.installing;
          installingWorker.addEventListener('statechange', () => {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // SW baru tersedia - update halaman
                console.log('[PWA] New content available; please refresh.');
                // Dispatch event untuk App.js
                window.dispatchEvent(new CustomEvent('sw-update-available'));
              } else {
                console.log('[PWA] Content cached for offline use.');
              }
            }
          });
        });
      })
      .catch((error) => {
        console.error('[PWA] Service Worker registration failed:', error);
      });

    // Handle SW updates from App.js
    window.addEventListener('sw-activate-update', () => {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' });
      }
    });

    // Reload page when new SW takes over
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        refreshing = true;
        window.location.reload();
      }
    });
  });
} else {
  console.log('[PWA] Service Worker not supported in this browser.');
}

